import { MutationTypeCodes, ResourceTypeMutationCodes, } from '@/store/interfaces';
export const mutations = {
    [MutationTypeCodes.SET_CURRENT_RESPONSE](state, payload) {
        state.currentResponse = JSON.parse(JSON.stringify(payload));
    },
    [MutationTypeCodes.SET_CURRENT_SEARCH_REQUEST](state, payload) {
        state.currentSearchRequest = JSON.parse(JSON.stringify(payload));
    },
    [MutationTypeCodes.RESET_FILTERS](state) {
        state.currentSearchRequest = JSON.parse(JSON.stringify(state.defaultSearchRequest));
    },
    [MutationTypeCodes.ADD_CATEGORY](state, payload) {
        const cats = state.currentSearchRequest.SearchCriteria.categories ?? [];
        if (!cats.includes(payload)) {
            cats.push(payload);
        }
        state.currentSearchRequest.SearchCriteria.categories = cats;
    },
    [MutationTypeCodes.REMOVE_CATEGORY](state, payload) {
        const cats = state.currentSearchRequest.SearchCriteria.categories ?? [];
        const index = cats.indexOf(payload, 0);
        if (index > -1) {
            cats.splice(index, 1);
        }
        state.currentSearchRequest.SearchCriteria.categories = cats;
    },
    [MutationTypeCodes.SET_SORT_OPTION](state, payload) {
        state.currentSearchRequest.Sort = payload;
    },
    [MutationTypeCodes.SET_SEARCH_STATUS](state, payload) {
        state.isSearching = payload;
    },
    [MutationTypeCodes.RESET_OFFSET](state) {
        state.currentSearchRequest.Offset = 0;
    },
    // Resource specific mutations
    [ResourceTypeMutationCodes.SET_RESOURCE_TYPE](state, payload) {
        state.currentSearchRequest.SearchCriteria.ResourceType = payload;
    },
    [ResourceTypeMutationCodes.REMOVE_RESOURCE_TYPE](state) {
        state.currentSearchRequest.SearchCriteria.ResourceType = undefined;
    },
};
